import { Check } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

import type { PresetRange } from '../../lib/date-utils';

interface PresetButtonProps {
  preset: PresetRange;
  isSelected: boolean;
  onSelect: () => void;
}

export function PresetButton({ preset, isSelected, onSelect }: PresetButtonProps) {
  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn('w-full justify-between mb-1', isSelected && 'bg-accent')}
      onClick={onSelect}>
      <span className="text-sm">{preset.label}</span>
      {isSelected && <Check className="h-3 w-3 text-primary" />}
    </Button>
  );
}
